// Copyright 2021 Prescryptive Health, Inc.

export class NonFatalError extends Error {
  constructor() {
    super();
    Object.setPrototypeOf(this, NonFatalError.prototype);
  }
}
